import { render, staticRenderFns } from "./ProgressDetailv2.vue?vue&type=template&id=ceec39ce&scoped=true"
import script from "./ProgressDetailv2.vue?vue&type=script&lang=js"
export * from "./ProgressDetailv2.vue?vue&type=script&lang=js"
import style0 from "./ProgressDetailv2.vue?vue&type=style&index=0&id=ceec39ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceec39ce",
  null
  
)

export default component.exports